<script lang="ts">
	let { class: classes = '', dashed = true } = $props();
</script>

<div class={['relative', classes]}>
	{#if !dashed}
		<div class="bg-gray-dark absolute -top-1 left-0 h-2 w-2 rounded-full"></div>
	{/if}
	<div class={['border-gray-dark flex-1 border-t-1', dashed && 'border-dashed']}></div>
	<div class="bg-gray-dark absolute -top-1 right-0 h-2 w-2 rounded-full"></div>
</div>
